module.exports = __webpack_public_path__ + "media/images/firsttime_contents04_pc-a9eda2cf78342d03160578cfe4a265f0.png";